/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CustomMetricConfigurationDetails {
    getFixupPrototypeFunction() { return CustomMetricConfigurationDetails.fixupPrototype; }

    static newInstance(model: Partial<CustomMetricConfigurationDetails>): CustomMetricConfigurationDetails {
        let obj = Object.assign(new CustomMetricConfigurationDetails(), model);
        CustomMetricConfigurationDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CustomMetricConfigurationDetails>): CustomMetricConfigurationDetails {
        if (!model) return null;
        return CustomMetricConfigurationDetails.newInstance(<CustomMetricConfigurationDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CustomMetricConfigurationDetails) {
        if (!obj) return;

        models.CustomMetricConfigurationDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CustomMetricConfigurationDetails): boolean {
        Object.setPrototypeOf(obj, CustomMetricConfigurationDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.threshold === undefined) {
            this.threshold = 0;
        }
        if (this.period === undefined) {
            this.period = 0;
        }
        if (this.evaluation_period === undefined) {
            this.evaluation_period = 0;
        }
        if (this.priority === undefined) {
            this.priority = 0;
        }
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Cloud Account Id for which custom metrics needs to be created.
     */
    service_account_id: string;

    /**
     * Region in which custom metrics to be created.
     */
    regions: Array<string>;

    /**
     * Name of the Resource category.
     */
    resource_category: string;

    /**
     * Type of the Resource.
     */
    resource_type: string;

    /**
     * Name of the Resource.
     */
    resource: string;

    /**
     * The namespace for the metric specified in metric_name.
     */
    metric_namespace: string;

    /**
     * The name for the metric associated with the alarm.
     */
    metric_name: string;

    /**
     * Status of the custom Metric Configuration
     */
    status: models.CustomMetricConfigurationStatus;

    /**
     * The value against which the specified statistics is compared.
     */
    threshold: number;

    /**
     * The arithmetic operation to use when comparing the specified statistics and threshold.
     */
    comparison_operator: models.CustomMetricThresholdOperator;

    /**
     * The statistics for the metric specified in MetricName.
     */
    statistic: models.CustomMetricStatistics;

    /**
     * Length in seconds used each time when metric is evaluated. Valid values are 10, 30 and any multiple of 60.
     */
    period: number;

    /**
     * The number of periods over which data is compared to the specified threshold.
     */
    evaluation_period: number;

    /**
     * Order of priority if there is multiple rules for same metric under a cloud account for a region
     */
    priority: number;

    /**
     * List of tag key/value pairs
     */
    tags: Array<models.KeyValuePair>;

    /**
     * List events for a selected resource in Event subscription
     */
    events: Array<models.EventSubscriptionResourceType>;

}
